export const EnvironmentTypes = {
  Development: 'development',
  Staging: 'staging',
  Production: 'production',
};
